import RepositoryFactory from "@/builder/apis";
const design = RepositoryFactory.design;

export default {
  getDesigns({ commit }, payload = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await design.getDesigns(payload);

        commit("SET_DESIGNS", data.data);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  uploadDesign({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await design.uploadDesign(payload);

        commit("UPDATE_DESIGN", data.data);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  deleteDesign({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await design.deleteDesign(payload);

        commit("UPDATE_DESIGN", data.data);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  addNote({ commit }, payload = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await design.addNote(payload);
        if (data.data) {
          await commit("SET_NOTE", data.data);
          await commit("TOGGLE_NOTES", {
            task: data.data.task,
            note: data.data,
            isCurrent: true,
          });
        }

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  addComment({ commit }, payload = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await design.addComment(payload);

        if (data.data) {
          commit("SET_COMMENT", data.data);
        }

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  addImageComment({ commit }, payload = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await design.addImageComment(payload);

        if (data.data) {
          commit("SET_COMMENT", data.data);
        }

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  mapDesigns({}, payload = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await design.mapDesigns(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
